import React, { createContext, useMemo, type ReactNode } from 'react';
import {
	getBrowserTimeZone,
	SYDNEY_TIMEZONE,
} from '@atlassian/jira-platform-utils-datetime/src/index.tsx';

type ProviderProps = {
	children: ReactNode;
	value?: string;
};

const { Provider, Consumer: TimeZoneConsumer } = createContext<string>(SYDNEY_TIMEZONE);

const TimezoneProvider = (props: ProviderProps) => {
	const { children, value } = props;

	// Set default again if one attribute is undefined
	const memoizedValue = useMemo(() => value ?? getBrowserTimeZone(), [value]);

	return <Provider value={memoizedValue}>{children}</Provider>;
};

export { TimeZoneConsumer, TimezoneProvider };
